var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 60,
    fill: "none",
    viewBox: "0 0 59 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.833,
    d: "M35.383 47.5v-.312c0-2.319 1.447-4.34 3.258-5.787a14.585 14.585 0 1 0-18.185 0c1.814 1.45 3.26 3.468 3.26 5.787v.312m11.667 0v5.833a2.917 2.917 0 0 1-2.916 2.917h-5.834a2.917 2.917 0 0 1-2.916-2.917V47.5m11.666 0H23.716M6.216 30H3.3m49.583 0H55.8M29.55 6.667V3.75m-16.5 9.75-2.062-2.062M46.047 13.5l2.065-2.062M29.55 38.75v-5.833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.e5ef8434313bc381466d71a3b0217a56.svg";
export { ForwardRef as ReactComponent };